export { MinimalFooter, type MinimalFooterProps } from "./MinimalFooter";
